import React from 'react';
import { AUTO_INSIGHTS_ALERTS_MORE } from '@src/utils/sensor/track';
import useDrawerState from '../Hooks/useDrawerState';
import { Insights, MoreDrawer } from './Insights';

function AlertInsights() {
  const { visible, openDrawer, closeDrawer } = useDrawerState({
    trackKey: AUTO_INSIGHTS_ALERTS_MORE,
  });

  return (
    <>
      <Insights openMore={openDrawer} />
      <MoreDrawer visible={visible} closeMore={closeDrawer} />
    </>
  );
}

export default AlertInsights;
